import Reveal from "@/components/base/Reveal";

const bullets = [
  "як відгуки з OLX Робота потрапляють у HURMA",
  "про картки кандидатів та дублікати",
  "як оцінювати OLX Робота разом з іншими каналами",
  "про аналітику, звітність та управлінські дані",
];

export default function FinalCta() {
  return (
    <section id="cta" className="scroll-mt-16 bg-white">
      <div className="mx-auto max-w-5xl px-4 py-24 md:px-6 md:py-32">
        <div className="text-center">
          <Reveal>
            <h2 className="font-heading text-4xl font-extrabold leading-tight tracking-tight text-foreground-950 md:text-6xl">
              Менше таблиць.
              <br />
              <span className="peach-gradient-text">Більше наймів.</span>
            </h2>
          </Reveal>

          <Reveal delay={100}>
            <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-foreground-600 md:text-xl">
              Залиште заявку на демо — покажемо, як скоротити шлях від відгуку до першого дзвінка 
              без таблиць, пересилань і ручної звірки:
            </p>
          </Reveal>
        </div>

        <Reveal delay={200}>
          <ul className="mx-auto mt-12 max-w-lg space-y-4">
            {bullets.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span className="mt-0.5 shrink-0 text-primary-500">
                  <i className="ri-check-line text-3xl"></i>
                </span>
                <span className="text-base text-foreground-600">{item}</span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={300}>
          <div className="mt-14 text-center">
            <button
              type="button"
              onClick={() => {
                window.location.href = "https://hurma.work/request-2/";
              }}
              className="inline-block whitespace-nowrap rounded-full bg-primary-500 px-10 py-4 text-lg font-semibold text-white transition-colors hover:bg-primary-600 cursor-pointer"
            >
              Запланувати демо
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}